if (!window.dailyFacialBundleSubmitBound) {
  window.dailyFacialBundleSubmitBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-daily-bundle-submit]');
    const form = button?.closest('[data-daily-bundle-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form);
  }, { capture: true });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-daily-bundle-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form);
  }, { capture: true });

  async function addToCart(form) {
    if (form.getAttribute('aria-busy') === 'true') return;

    const button = form.querySelector('[data-daily-bundle-submit]');
    const status = form.querySelector('[data-daily-bundle-status]');
    if (!button || !status || button.disabled) return;

    const bundleVariant = form.querySelector('[data-bundle-variant]');
    const itemVariants = Array.from(form.querySelectorAll('[data-bundle-item]'));
    const variants = bundleVariant ? [bundleVariant.value] : itemVariants.map((input) => input.value);

    if (variants.length === 0 || variants.some((id) => !id)) {
      status.dataset.error = '';
      status.textContent = form.dataset.error;
      return;
    }

    status.textContent = '';
    delete status.dataset.error;
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: variants.map((id) => ({ id, quantity: 1 })),
        }),
      });
      const result = await response.json();

      if (!response.ok) {
        throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
      }

      status.textContent = form.dataset.success;

      try {
        if (!window.StepLabsSidecart) {
          throw new Error(form.dataset.sidecartError);
        }
        await window.StepLabsSidecart.open(form.dataset.sidecartError);
      } catch (error) {
        console.error('[c-daily-facial-bundle] Sidecart could not be opened:', error);
        status.dataset.error = '';
        status.textContent = form.dataset.sidecartError;
      }
    } catch (error) {
      console.error('[c-daily-facial-bundle] Add to cart failed:', error);
      status.dataset.error = '';
      status.textContent = error instanceof Error ? error.message : form.dataset.error;
    } finally {
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }
}
